import CalendarArea from "./calendar";

function SelectDateArea(props:any){
   let myProps={
    select_date:"",
    select_date_arr:[],
    set_select_date_arr:()=>{},
    able_days_of_week:[],
    ...props
  };

  return (
  <div>
    <CalendarArea
      select_date={myProps.select_date}
      select_date_arr={myProps.select_date_arr}
      set_select_date_arr={myProps.set_select_date_arr}
      able_days_of_week={myProps.able_days_of_week}
    ></CalendarArea>
  </div>
  );
};
export default SelectDateArea;